import service from "services/maintenance/holidayService";
import { CakeOutlined } from "@mui/icons-material";
import MAINTENANCE_STORE_SELECTORS from "features/maintenance/dataStore/selectors";

const loanTypeResource = {
    title: "Holidays",
    singular: "Holiday",
    displayField: "description",
    service: service,
    pageIcon: CakeOutlined,
    setter: MAINTENANCE_STORE_SELECTORS.HOLIDAY,

    columns: [
        {
            field: "holidayCode",
            header: "Holiday Code",
            width: "15%"
        },
        {
            field: "description",
            header: "Description"
        },
        {
            field: "holidayDate",
            header: "Date"
        },
        {
            field: "createdByName",
            header: "Created By",
            width: "10%"
        },
        {
            field: "updatedByName",
            header: "Updated By",
            width: "10%"
        }
    ],
    fields: [
        {
            name: "holidayCode",
            label: "Holiday Code",
            type: "text",
            required: true,
            unique: true
        },
        {
            name: "description",
            label: "Description",
            type: "text",
            required: true
        },
        {
            name: "holidayDate",
            label: "Date",
            type: "date",
            required: true
        }
    ],
    searchFields: ["description"]
};

export default loanTypeResource;
